export default __webpack_public_path__ + "static/media/Wildstrider Boots.7aef0b5a.jpg";